import React from "react";
import styles from "./Header.style";
import {Div, Text} from "@vkontakte/vkui";

const Header = () => {
    return (
        <Div style={styles.wrapper}>
            <Text style={styles.firstLine}>госуслуги</Text>
            <Text style={styles.secondLine}>здоровье</Text>
        </Div>
    )
}

export default Header;